import { constructFrom } from "../constructFrom.js";
export function normalizeDates(context) {
  for (var _len = arguments.length, dates = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    dates[_key - 1] = arguments[_key];
  }
  const normalize = constructFrom.bind(null, context || dates.find(date => typeof date === "object"));
  return dates.map(normalize);
}